import { render, staticRenderFns } from "./LoadingIcon.vue?vue&type=template&id=44e6c8c9&scoped=true&"
import script from "./LoadingIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LoadingIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e6c8c9",
  null
  
)

export default component.exports